import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React from "react";
import {
  getLabelTagsArray,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import { symptomsOptions } from "../../Options/psychologistOptions";
import symptomsIcon from "../../../../assets/doctorIcons/symptoms.svg";
import { checkEmpty } from "../../../../helpers/utility";

const PsychologistSymptomsSummary = ({ formData }) => {
  const constructSymptomsSummaryItems = () => {
    const symptomsSummaryItems = [];
    if (checkEmpty(formData?.symptoms)) {
      symptomsSummaryItems.push({
        key: "1",
        label: "Symptoms",
        children: (
          <>
            {getLabelTagsArray(symptomsOptions, formData?.symptoms?.symptoms)}
            {getLabelTagsWithDynamicInputs(formData?.symptoms?.others)}
          </>
        ),
      });
    }
    return symptomsSummaryItems;
  };
  const symptomsSummaryItems = constructSymptomsSummaryItems();
  return (
    <SummaryWrapper
      items={symptomsSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={symptomsIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Symptoms/Impressions
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default PsychologistSymptomsSummary;
